import { render, staticRenderFns } from "./manufacture-create.vue?vue&type=template&id=6cab1558&scoped=true&"
import script from "./manufacture-create.vue?vue&type=script&lang=js&"
export * from "./manufacture-create.vue?vue&type=script&lang=js&"
import style0 from "./manufacture-create.vue?vue&type=style&index=0&id=6cab1558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cab1558",
  null
  
)

export default component.exports